var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 1.75H5.25C4.78587 1.75 4.34075 1.93437 4.01256 2.26256C3.68437 2.59075 3.5 3.03587 3.5 3.5V17.5C3.5 17.9641 3.68437 18.4092 4.01256 18.7374C4.34075 19.0656 4.78587 19.25 5.25 19.25H15.75C16.2141 19.25 16.6592 19.0656 16.9874 18.7374C17.3156 18.4092 17.5 17.9641 17.5 17.5V7.875L11.375 1.75Z",
    stroke: "#9E9E9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 1.75V7.875H17.5",
    stroke: "#9E9E9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesIcon);
export default __webpack_public_path__ + "static/media/resources_icon.5a8a073e5ddb44ed67aad374f40644cc.svg";
export { ForwardRef as ReactComponent };